export class UserConfigurations {
  id: string;
  projectId: number;
  modelRunId: string;
  userId: string;
  configType: string;
  configurations: any;
}
